/**
 *
 * MeasurementColorRange
 *
 */

import React, { Fragment } from "react"

import "./index.less"
import { QuestionCircleFilled } from "@ant-design/icons"
import { uuid } from "../../utils/functions"
import { loadTexts } from "../../utils/i18n"

const MeasurementColorRange = ({ measureColorRange, sizeText }) => {
  const intlMeasurementColorRange = loadTexts("reports_general_view")
    .reportHeaderV2.measurementColorRange
  const renderIconQuestion = () => {
    return (
      <QuestionCircleFilled className="MeasurementColorRange-icon-question" />
    )
  }

  const renderTitle = () => {
    return (
      <div className="MeasurementColorRange-title-popover">
        {intlMeasurementColorRange.tooltipLegend}
      </div>
    )
  }

  const renderLegendColor = (item) => {
    return (
      <div key={uuid()}>
        <div className="MeasurementColorRange-content">
          <div
            className="MeasurementColorRange-color"
            style={{
              background: `rgb(${item.rgb.r},${item.rgb.g},${item.rgb.b})`,
            }}
          />
          <div className="MeasurementColorRange-label-value">{`${item.start} ${intlMeasurementColorRange.to} ${item.finish}`}</div>
        </div>
        {Number(item.finish) !== 100 && (
          <hr className="MeasurementColorRange-divider" />
        )}
      </div>
    )
  }

  const renderContent = () => {
    let data = measureColorRange.filter((item) => !item.disabled)

    return data.map((item) => renderLegendColor(item))
  }

  // Validation has not data
  if (measureColorRange === null || measureColorRange.length === 0) return null

  return (
    <div className="MeasurementColorRange">
      <div
        className="MeasurementColorRange-text"
        style={{ fontSize: sizeText }}>
        {intlMeasurementColorRange.legend}
      </div>
      <div className="popover__wrapper">
        {renderIconQuestion()}
        <div className="popover__content">
          <div>
            <div className="popover__title">{renderTitle()}</div>
            <div>{renderContent()}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

MeasurementColorRange.defaultProps = {
  measureColorRange: [],
  sizeText: 13,
}

export default MeasurementColorRange
